import { type z } from 'zod'

import { type schemas } from '~interface/zod-schema'

import { type Identity0 } from './cases'
import type { AccessAction } from './permissions'

export type ContactEmail0 = z.infer<typeof schemas.ContactEmail0>
export type AccessResourceTypeEnum = z.infer<typeof schemas.AccessResourceTypeEnum>
export const AccessResourceCase: AccessResourceTypeEnum = 'case'
export const AccessResourceWorkflow: AccessResourceTypeEnum = 'workflow'

export type EmailParticipantType = z.infer<typeof schemas.EmailParticipantTypeEnum>
export type EmailRecipientType = Exclude<EmailParticipantType, 'from'>
export const EMAIL_RECIPIENT_TYPES: EmailRecipientType[] = ['to', 'cc', 'bcc']

export type DraftCommunication = z.infer<typeof schemas.DraftCommunicationMessageViewResponseData>
export type DraftCommunicationRecipient = DraftCommunication['recipients'][number]

export type Email1 = z.infer<typeof schemas.Email1>
export type EmailParticipant0 = z.infer<typeof schemas.EmailParticipant0>

export type VerifyOptions = z.infer<typeof schemas.VerifyOptions>
export type VerifyTypeEnum = z.infer<typeof schemas.VerifyTypeEnum>
export const VerifyTypeVerifyAdmin: VerifyTypeEnum = 'admin'
export const VerifyTypeVerifyApply: VerifyTypeEnum = 'apply'
export const VerifyTypeVerifyPayment: VerifyTypeEnum = 'payment'
export const VerifyTypeVerifyStandard: VerifyTypeEnum = 'standard'
export const VerifyTypeVerifyThread: VerifyTypeEnum = 'thread'
export const VerifyTypeVerifyAccessGrant: VerifyTypeEnum = 'access_grant'

export type VerifyAdmin = z.infer<typeof schemas.VerifyAdmin>
export type VerifyApply = z.infer<typeof schemas.VerifyApply>
export type VerifyPayment = z.infer<typeof schemas.VerifyPayment>
export type VerifyStandard = z.infer<typeof schemas.VerifyStandard>
export type VerifyThread = z.infer<typeof schemas.VerifyThread>
export type VerifyAccessGrant = z.infer<typeof schemas.VerifyAccessGrant>

export const createVerifyAdmin = (identity: Identity0): VerifyOptions => ({
  type: VerifyTypeVerifyAdmin,
  admin: { identity: identity },
})

export const createVerifyStandard = (uri: string | null): VerifyOptions => ({
  type: VerifyTypeVerifyStandard,
  standard: { uri: uri },
})

export const createVerifyAccessGrant = (
  resourceType: AccessResourceTypeEnum,
  accessLevel: AccessAction,
  resourceName: string,
  uri: string | null,
): VerifyOptions => ({
  type: VerifyTypeVerifyAccessGrant,
  access_grant: {
    resource_type: resourceType,
    resource_name: resourceName,
    access_level: accessLevel,
    uri: uri,
  },
})
